import React, { Component } from 'react'
import { message } from 'antd'
import PageWarp from '../../components/PageWrap'
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { post, postFrom, config } from '../../axios';
import { formatTime } from '../../utils/index'
import { dicBuildingStatus } from '../../axios/dictionaries'
import TemplateUpdate from './components/TemplateUpdate'

export default class Template extends Component {
  state = {
    loading: false, // 页面加载
    queryData: {
      keyword: '',
      pageSize: 10,
      current: 1, // 当前页
    },
    tableData: {
      loading: false,
      total: 0,
      list: []
    }
  }

  componentDidMount() {
    this.postFindPage()
  }

  handleSearch = (values = {}) => { // 查询
    const { queryData } = this.state
    let data = {}

    data = Object.assign({}, queryData, values);
    this.setState({ queryData: data })
    this.postFindPage(data)
  }

  handleAdd = () => {
    this.templateUpdateRef && this.templateUpdateRef.onShow({})
  }

  handleEdit = (id) => { // 编辑
    post({
      url: config.API_contracttemplate_getById,
      data: { id }
    }).then(res => {
      this.templateUpdateRef && this.templateUpdateRef.onShow(res)
    }).catch(err => {
      message.error(err.message || '获取详情失败');
    })
  }

  postFindPage(data = {}) { // 列表获取
    const { queryData, tableData } = this.state
    this.setState({
      tableData: { ...tableData, loading: true }
    })
    postFrom({
      url: config.API_contracttemplate_findPage,
      data
    }).then(res => {
      const { current, total, records } = res
      this.setState({
        queryData: { ...queryData, current },
        tableData: { list: records, total, loading: false }
      })
    }).catch(err => {
      message.error(err.message || '获取列表失败');
      this.setState({ tableLoading: false });
    })
  }

  searchFormItem = [
    {
      tagName: 'Input',
      formConfig: { name: 'keyword' },
      attribute: { placeholder: '请输入关键字', style: { width: '130px' } },
    },
  ]

  columns = handleEdit => [
    { title: '模板名称', dataIndex: 'name' },
    { title: '模板编号', dataIndex: 'templateNo' },
    { title: '备注', dataIndex: 'remark' },
    { 
      title: '状态', dataIndex: 'status',
      render(text) {
        if (!text) return '-'
        const item = dicBuildingStatus.find(item => item.value === text)
        if (!item) return '-'
        return <span style={{ color: item.color }}>{item.title}</span>;
    }
    },
    { 
      title: '创建时间', dataIndex: 'createTime',
      render(text) {
        if (!text) return '-'
        return formatTime(text)
      }
    },
    {
      title: '操作', dataIndex: 'id',
      render(text) {
          return (
            <div>
              <AuthButton authkey="d-3-2">
                <span className="showClickDetail" onClick={() => { handleEdit(text) }}>编辑</span>
              </AuthButton>
            </div>
          )
      }
    }
  ]

  render() {
    const {
      state: { 
        loading,
        tableData: { list, total, loading: tableLoading },
        queryData: { current },
      },
      searchFormItem,
      columns,
      handleSearch,
      handleAdd,
      handleEdit
    } = this

    return (
      <PageWarp loading={loading}>
        <div className="search-wrapper">
          <div className="search-btn-list">
              <AuthButton authkey="d-3-1" type="primary" icon="plus" onClick={handleAdd}>新增</AuthButton>
          </div>
          <SuperForm
            data={searchFormItem}
            sumbit={handleSearch}
          />
        </div>

        <TableDOM
          columns={columns(handleEdit)}
          loading={tableLoading}
          data={list}
          total={total}
          current={current}
          onChange={handleSearch}
        />

        <TemplateUpdate 
          onRef={ref => this.templateUpdateRef = ref}
          onUpdate={() => { this.postFindPage() }}
        />
      </PageWarp>
    )
  }
}


// WEBPACK FOOTER //
// ./src/page/RentContract/Template.jsx